module.exports = __webpack_public_path__ + "img/text.0b818c6d.png";